import { blue, brown, grey, red, teal } from "@mui/material/colors";

export const colors = {
	// Browns
	bright: brown[500],
	brightest: brown[300],
	buttonLink: brown[300], // #AC9C8C
	buttonHover: brown[200],
	checkboxChecked: brown[600],
	darkBg: brown[700],
	dialogTitleBg: brown[900],
	headerBg: brown[900],
	icon: brown[800],
	infoHighlight: brown[700],
	linkHighlight: brown[100],
	neutral: brown[100],
	optionBg: brown[100],
	pageBg: brown[100],
	submitBg: brown[600],

	// Greys
	activeRouteBorder: grey[400],
	dark: grey[900],
	dull: grey[500],
	fadedBg: grey[300],

	light: grey[200],
	lightBg: grey[50],
	checkboxFontColor: grey[800],
	shine: grey[400],
	stepButtonBg: grey[100],
	stepButtonHover: grey[300],
	stepButtonBorder: grey[300],

	// Blues
	activeRoute: blue[900],
	listTitleBgcolor: blue[100],
	navActiveBgcolor: blue[50],
	navHighlight: blue[700],
	secondary: blue[800],
	selectedListitemBgColor: blue[100],

	// Teals
	info: teal[600],
	link: teal[200],
	success: teal[500],

	// Reds
	cancel: red[500],
	error: red[500],
	remove: red[500],

	// Absolute
	backgroundDefault: "#fff",
	darkest: "#000",
	lightest: "#fff",
} as const;
